@if (svg()) {
  <span
    class="app-icon app-icon__injected"
    [innerHTML]="svg()"
    [ngStyle]="styles"
  ></span>
} @else if (name()) {
  <i-lucide [name]="name()" class="app-icon" [ngStyle]="styles" />
}
